import React from "react";
import './RevenuSection.css';

export const RevenuSection = (props) => {
  const handleRevenu = (e) => {
    props.setRevenu(e.target.value);
  }
  return (
    <section style={{display: !props.ThankShow ? 'block' : 'none'}}>
      <h1 className="heading_text mt-5">
        اكتب باختصار المشاكل التي تواجهك الان في عملك وتمنعك من التوسع والتقدم{" "}
      </h1>
      <div className="d-flex flex-column align-items-center">
        <textarea cols="70" rows="8" dir="rtl" className="my-3 revenu_textarea" value={props.revenuText} onChange={handleRevenu}></textarea>
        <button type="button" className="input_button button_width" onClick={props.submitData}>
          المتابعة <i className="fa fa-long-arrow-right ms-2" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  );
};
